export default {
  processedLayout: {},
  // Layout state management
  currentLayout: {
    LayoutId: "",
    LayoutName: "",
    Stalls: [],
    Objects: [],
  },
  editingPath: [], // Array of indices showing current editing context e.g., [0, 2, 1] for Objects[0].Objects[2].Objects[1]
  availableProducts: [],
  availableColors: [],
  layoutAction: "create", // 'create' or 'update'

  // allEventsByYear: [],
  // Theses are used in the "Backend" admin vues
  // TODO: Rewrite all components to use the currentStallholder and currentStall variables. Instead of EACH component having a watch on globalEventFilter to set individual variables.
  currentEvent: {},
  currentStallHolders: [],
  currentStallholder: null,
  currentStalls: [],
  currentStall: null,
  currentStallTags: [],

  currentEventManagementTab: "Events",
  currentProductManagementTab: "Categories",

  eventSelectorDisabled: false,
};
